<template>
  <div>
    <v-container fluid class="py-6">
      <v-row>
        <v-col lg="12" class="mx-auto">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 pt-4">
              <div class="d-flex align-center">
                <div>
                  <h6 class="text-h6 text-typo font-weight-bold mb-2">
                    Return Status
                  </h6>
                  <p class="text-sm text-body mb-0"> Week - <b>{{ batchInfo.week_number }} </b> </p>
                </div>
                <v-btn
                    elevation="0"
                    small
                    :ripple="false"
                    height="21"
                    class="
                          border-radius-sm
                          text-xxs
                          font-weight-bolder
                          px-3
                          py-2
                          badge-font-size
                          ms-auto
                          text-white
                        "

                    color="#cdf59b"
                    :class = "batchInfo.status != 'Approved'? 'bg-gradient-warning' : 'bg-gradient-success'"
                >{{ batchInfo.status }}</v-btn
                >
                <v-btn
                    elevation="0"
                    :ripple="false"
                    height="43"
                    class="
                    font-weight-bold
                    text-uppercase
                    btn-default
                    bg-gradient-secondary
                    py-2
                    px-6
                    me-2
                    ms-auto
                  "
                    color="#5e72e4"
                    small
                >{{ batchInfo.batchnumber }}</v-btn
                >
              </div>
            </div>
            <hr class="horizontal dark mt-4 mb-6" />
            <div class="px-4 pb-5" v-if="batchInfo.status == 'Pending POP'">
              <v-row>
                <v-col
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                    class="align-content-center justify-content-center"
                >
                  <h6 class="text-h6 text-typo font-weight-bold mb-3">
                    Upload Proof of Payment
                  </h6>
                  <input class="mt-3" type="file" ref="myFile" hidden>
                  <v-file-input
                      v-model="files"
                      accept=".pdf , .jpg , .png, .jpeg"
                      label="Click here to upload POP"
                      multiple
                      outlined
                      class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                          small
                          label
                          color="secondary"
                          style="color: #1a252f"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                  <br>
                  <v-btn
                      :disabled="files.length < 1"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="
                    font-weight-bold
                    text-uppercase
                    btn-default
                    bg-gradient-primary
                    py-2
                    px-6
                    me-2
                    ms-auto
                    ce
                  "
                      color="#5e72e4"
                      small
                      @click="uploadFile()"
                  >
                    <v-icon size="15" class="mr-2">fas fa-credit-card </v-icon>
                    Upload Proof of Payment
                  </v-btn>

                </v-col>
                <v-col lg="4" md="12" sm="12" class="ms-auto">
                  <h6 class="text-h6 text-typo font-weight-bold mb-3 mr-8 pr-5">
                    Payment Summary
                  </h6>
                  <div class="d-flex">
                    <span class="mb-2 text-body text-sm"> Returns: </span>
                    <span class="text-dark font-weight-bold ms-auto"
                    >$USD {{formatPrice(batchInfo.amount)}}</span
                    >
                  </div>
                  <div class="d-flex">
                    <span class="mb-2 text-body text-sm"> Penalty: </span>
                    <span class="text-dark font-weight-bold ms-auto"
                    >$USD {{formatPrice(0)}}</span
                    >
                  </div>
                  <div class="d-flex mt-6">
                    <span class="mb-2 text-body text-md"> Total: </span>
                    <span
                        class="text-dark text-lg ms-2 font-weight-bold ms-auto"
                    >$USD {{formatPrice(batchInfo.amount)}}</span
                    >
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col  lg="12" class="mx-auto">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 pt-4 pb-4">
              <div class="d-flex align-center">
                <div>
                  <h6 class="text-h6 text-typo font-weight-bold mb-2">
                    Current Comment
                  </h6>
                  <p class="text-sm text-body mb-0 text--primary">{{ batchInfo.comment }}</p>
                </div>
              </div>
            </div>
            <hr class="horizontal dark mt-4 mb-6" />
          </v-card>
        </v-col>
        <v-col md="12">
          <v-card class="card-shadow border-radius-xl h-100">
            <div class="px-4 pt-5 d-flex align-center">
              <h6 class="mb-0 text-typo text-h6 font-weight-bold">
                Your Returns
              </h6>
              <div class="text-body ms-auto">
                <v-icon class="text-body" size="16"
                >far fa-file me-1</v-icon
                >
                <small>{{ batchInfo.batchnumber }}</small>
              </div>
            </div>
            <div class="px-4 pt-6">
              <v-data-table
                  :headers="headers"
                  :items="batchInfo.returns"
                  :search="search"
                  class="table"
                  :page.sync="page"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  :items-per-page="itemsPerPage"
                  mobile-breakpoint="0"
              >
                <template v-slot:top>
                  <v-toolbar flat height="80">
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-text-field
                            hide-details
                            class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                            dense
                            flat
                            filled
                            solo
                            height="43"
                            v-model="search"
                            placeholder="Search"
                        >
                          <template slot="prepend-inner">
                            <v-icon color="#adb5bd" size=".875rem"
                            >fas fa-search</v-icon
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:item.name="{ item }">
                  <span class="text-body text-sm">{{ item.emp_firstname }} </span>
                </template>
                <template v-slot:item.general_fund="{ item }">
                  <span class="text-body text-sm">$ {{ formatPrice(item.general_fund) }} </span>
                </template>
                <template v-slot:item.weeksCount="{ item }">
                  <span class="text-body text-sm">{{ item.weeksCount }} </span>
                </template>
                <template v-slot:item.emp_idnumber="{ item }">
                  <span class="text-body text-sm">{{ item.emp_idnumber }} </span>
                </template>
                <template v-slot:item.class_grade="{ item }">
                  <span class="text-body text-sm">{{ item.class_grade }} </span>
                </template>
                <template v-slot:item.week_number="{ item }">
                  <span class="text-body text-sm">{{ item.week_number }} </span>
                </template>
              </v-data-table>
            </div>
            <v-card-actions class="card-padding">
              <v-row>
                <v-col cols="6" lg="3" class="d-flex align-center">
                  <span class="text-body me-3 text-sm">Items per page:</span>
                  <v-text-field
                      hide-details
                      type="number"
                      outlined
                      min="-1"
                      max="15"
                      background-color="rgba(255,255,255,.9)"
                      color="rgba(0,0,0,.6)"
                      light
                      :value="itemsPerPage"
                      @input="itemsPerPage = parseInt($event, 10)"
                      placeholder="Items per page"
                      class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="ml-auto d-flex justify-end">
                  <v-pagination
                      prev-icon="fa fa-angle-left"
                      next-icon="fa fa-angle-right"
                      class="pagination"
                      color="#cb0c9f"
                      v-model="page"
                      :length="pageCount"
                      circle
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Success
        </v-card-title>

        <v-card-text>
          Your Proof of Payment has been uploaded successfully
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="goTo()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          There was an error uploading your POP. Please try again
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false, goTo()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Invoice",
  data: function () {
    return {
      search: "",
      page: 1,
      successDialog: false,
      errorDialog: false,
      pageCount: 0,
      overlay: false,
      itemsPerPage: 4,
      batchInfo: [],
      files: [],
      headers: [
        {
          text: "Name",
          value: "name",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ID Number",
          value: "emp_idnumber",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Grade",
          value: "class_grade",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Weeks Worked",
          value: "weeksCount",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    ...mapState(['base_url', 'OrgId', 'isAuthenticated']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  created() {
    this.getBatchInfo()
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async getBatchInfo() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/returns/get-returns-info/' + this.$route.query.id)
          .then(res => {
            if (res.status === 200) {
              this.batchInfo = res.data
              console.log(this.batchInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    // upload file
    async uploadFile() {
      this.overlay = true
      let file = this.files[0];
      if (file) {
        const JWTToken = this.$store.getters.accessToken
        let formData = new FormData();
        formData.append('file', file);
        formData.append('email', this.email);
        const config = {
          method: "post",
          url: this.base_url + "/returns/submit-batch-pop/" + this.$route.query.id,
          headers: {
            // Authorization: `Bearer ${JWTToken}`,
            //'Content-Type': 'application/json',
            'Content-Type': 'multipart/form-data'
          },
          data: formData
        };
        axios(config)
            .then((response) => {
              if (response.status == '201') {
                this.getBatchInfo()
                this.overlay = false
                this.successDialog = true
                console.log(response)
              } else {
                console.log(response)
              }
              console.log(response)
            }).catch((error) => {
          console.log(error)
        });
      } else {
        this.overlay = false
        this.errorDialog = true
      }

    },
    goTo() {
      this.$router.push({name: 'Returns'})
    },
  },
};
</script>
